import React, { useEffect, useRef, useState } from "react";
import { classNames } from "primereact/utils";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import AppTopbar from "./AccountHomeTopbar";
import AppMenu from "./AccountLeftMenu";

import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";

import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import MyCompanies from "./MyCompanies";
import UnclaimedProfiles from "./admin/UnclaimedProfiles";
import AllProviders from "./admin/AllProviders";
import MyAccount from "./MyAccount";
import TokenService from "../../utils/TokenService";
import NewProvider from "./NewProvider";
import NewUnclaimedProfile from "./admin/NewUnclaimedProfile";
import AllUsers from "./admin/AllUsers";
import AllProfiles from "./admin/AllProfiles";
import FreeTrials from "./admin/FreeTrials";
import PaidSubscriptions from "./admin/PaidSubscriptions";
import CanceledSubscriptions from "./admin/CanceledSubscriptions";
import Promos from "./admin/Promos";
import UserEventLog from "./admin/UserEventLog";
import Events from "./admin/Events";
import AdminHome from "./admin/AdminHome";
import ExpiredFreeTrials from "./admin/ExpiredTrials";
import SuggestedOffers from "./admin/offers/SuggestedOffers";
import ServerMetrics from "./admin/ServerMetrics";
import MyReviews from "./MyReviews";
import MyFriends from "./MyFriends";
import AddFacebookFriends from "./AddFacebookFriends";
import NewUser from "./NewUser";
import ProviderEventLog from "./admin/ProvderEventLog";
import ImportCompanyData from "./admin/ImportCompanyData";
export const RTLContext = React.createContext();

const AccountHome = () => {
    const menuMode = "static";
    const [desktopMenuActive, setDesktopMenuActive] = useState(true);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [activeTopbarItem, setActiveTopbarItem] = useState(null);
    const [menuActive, setMenuActive] = useState(false);
    const inputStyle = "outlined";
    const isRTL = false;
    const ripple = true;
    const [mobileTopbarActive, setMobileTopbarActive] = useState(false);
    const menuTheme = "light";
    const topbarTheme = "cyan";
    const [inlineMenuActive, setInlineMenuActive] = useState({});
    const [searchActive, setSearchActive] = useState(false);
    const copyTooltipRef = useRef();
    let currentInlineMenuKey = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();

    PrimeReact.ripple = true;

    let searchClick;
    let topbarItemClick;
    let menuClick;
    let inlineMenuClick;

    const menuItems = [];
    if (TokenService.getProviderSubdomain()) {
        const manageProvidersMenu = {
            label: "Service Manager",
            icon: "pi pi-fw pi-home",
            url: TokenService.getProviderUrl()
        };
        menuItems.push(manageProvidersMenu);
    }
    const dashboardMenu = {
        to: "/account/select-provider",
        label: "My Companies",
        icon: "pi pi-fw pi-briefcase",
    };
    menuItems.push(dashboardMenu);
    const myAccountMenu = {
        to: "/account/profile",
        label: "My Account",
        icon: "pi pi-fw pi-user",
    };
    menuItems.push(myAccountMenu);
    const myReviewsMenu = {
        to: "/account/my-reviews",
        label: "My Reviews",
        icon: "pi pi-fw pi-star",
    };
    menuItems.push(myReviewsMenu);
    const myFriendsMenu = {
        to: "/account/my-friends",
        label: "My Friends",
        icon: "pi pi-fw pi-users",
    };
    menuItems.push(myFriendsMenu);
    if (TokenService.isWallistAdmin()) {
        const adminHomeMenu = {
            to: "/account/admin/home",
            label: "Wallist Administration",
            icon: "pi pi-fw pi-cog",
        };
        menuItems.push(adminHomeMenu);
    }
    
    const logoutMenu = {
        label: "Logout",
        icon: "pi pi-fw pi-power-off",
        url: "/logout",
    };
    menuItems.push(logoutMenu);
    const menu = [{ items: menuItems }];
    menu.concat(...menu, menuItems);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();

        const verifyUser = () => {
            if (!TokenService.isLoggedIn()) {
                navigate("/");
            }
        };
        verifyUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    useEffect(() => {
        if (menuMode === "overlay") {
            hideOverlayMenu();
        }
        if (menuMode === "static") {
            setDesktopMenuActive(true);
        }
    }, [menuMode]);

    const onMenuClick = (event) => {
        menuClick = true;
    };

    useEffect(() => {
        window.addEventListener("resize", function (event) {
            if (isDesktop()) {
                setDesktopMenuActive(true);
            }
        });
    }, []);

    const onMenuButtonClick = (event) => {
        menuClick = true;

        if (isDesktop()) setDesktopMenuActive((prevState) => !prevState);
        else setMobileMenuActive((prevState) => !prevState);

        event.preventDefault();
    };

    const onTopbarItemClick = (event) => {
        topbarItemClick = true;
        if (activeTopbarItem === event.item) setActiveTopbarItem(null);
        else {
            setActiveTopbarItem(event.item);
        }

        event.originalEvent.preventDefault();
    };

    const onSearch = (event) => {
        searchClick = true;
        setSearchActive(event);
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items && (menuMode === "overlay" || !isDesktop())) {
            hideOverlayMenu();
        }

        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const onRootMenuItemClick = (event) => {
        setMenuActive((prevState) => !prevState);
    };

    const onMobileTopbarButtonClick = (event) => {
        setMobileTopbarActive((prevState) => !prevState);
        event.preventDefault();
    };

    const onDocumentClick = (event) => {
        if (!searchClick && event.target.localName !== "input") {
            setSearchActive(false);
        }

        if (!topbarItemClick) {
            setActiveTopbarItem(null);
        }

        if (!menuClick && (menuMode === "overlay" || !isDesktop())) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
            }
            hideOverlayMenu();
        }

        if (inlineMenuActive[currentInlineMenuKey.current] && !inlineMenuClick) {
            let menuKeys = { ...inlineMenuActive };
            menuKeys[currentInlineMenuKey.current] = false;
            setInlineMenuActive(menuKeys);
        }

        if (!menuClick && (isSlim() || isHorizontal())) {
            setMenuActive(false);
        }

        searchClick = false;
        topbarItemClick = false;
        inlineMenuClick = false;
        menuClick = false;
    };

    const hideOverlayMenu = () => {
        setMobileMenuActive(false);
        setDesktopMenuActive(false);
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const isHorizontal = () => {
        return menuMode === "horizontal";
    };

    const isSlim = () => {
        return menuMode === "slim";
    };

    const layoutContainerClassName = classNames(
        "layout-wrapper ",
        "layout-menu-" + menuTheme + " layout-topbar-" + topbarTheme,
        {
            "layout-menu-static": menuMode === "static",
            "layout-menu-overlay": menuMode === "overlay",
            "layout-menu-slim": menuMode === "slim",
            "layout-menu-horizontal": menuMode === "horizontal",
            "layout-menu-active": desktopMenuActive,
            "layout-menu-mobile-active": mobileMenuActive,
            "layout-topbar-mobile-active": mobileTopbarActive,
            "p-input-filled": inputStyle === "filled",
            "p-ripple-disabled": !ripple,
            "layout-rtl": isRTL,
        }
    );
    return (
        <RTLContext.Provider value={isRTL}>
            <div className={layoutContainerClassName} onClick={onDocumentClick}>
                <Tooltip
                    ref={copyTooltipRef}
                    target=".block-action-copy"
                    position="bottom"
                    content="Copied to clipboard"
                    event="focus"
                />

                <AppTopbar
                    horizontal={isHorizontal()}
                    activeTopbarItem={activeTopbarItem}
                    onMenuButtonClick={onMenuButtonClick}
                    onTopbarItemClick={onTopbarItemClick}
                    onMobileTopbarButtonClick={onMobileTopbarButtonClick}
                    mobileTopbarActive={mobileTopbarActive}
                    searchActive={searchActive}
                    onSearch={onSearch}
                />

                <div className="menu-wrapper" onClick={onMenuClick}>
                    <div className="layout-menu-container">
                        <AppMenu
                            model={menu}
                            onMenuItemClick={onMenuItemClick}
                            onRootMenuItemClick={onRootMenuItemClick}
                            menuMode={menuMode}
                            active={menuActive}
                        />
                        <div className="block lg:hidden">
                            <hr className="mb-0 pb-0" />
                            <div className="pt-4 ml-4 p-1">Logged in as:<br />{TokenService.getUserName()}</div>
                        </div>
                    </div>
                </div>

                <div className="layout-main">
                    <div>
                        <Routes>
                            <Route path="welcome" element={<NewUser />} />
                            <Route path="profile" element={<MyAccount />} />
                            <Route path="my-reviews" element={<MyReviews />} />
                            <Route path="my-friends" element={<MyFriends />} />
                            {/* <Route path="add-facebook-friends" element={<AddFacebookFriends />} /> */}
                            <Route path="select-provider" element={<MyCompanies />} />
                            <Route path="new-provider" element={<NewProvider />} />
                            <Route path="admin/unclaimed-profiles" element={<UnclaimedProfiles />} />
                            <Route path="admin/new-profile" element={<NewUnclaimedProfile />} />
                            <Route path="admin/all-providers" element={<AllProviders />} />
                            <Route path="admin/all-profiles" element={<AllProfiles />} />
                            <Route path="admin/all-users" element={<AllUsers />} />
                            <Route path="admin/free-trials" element={<FreeTrials />} />
                            <Route path="admin/expired-free-trials" element={<ExpiredFreeTrials />} />
                            <Route path="admin/subscriptions" element={<PaidSubscriptions />} />
                            <Route path="admin/canceled-subscriptions" element={<CanceledSubscriptions />} />
                            <Route path="admin/promos" element={<Promos />} />
                            <Route path="admin/user-events" element={<UserEventLog />} />
                            <Route path="admin/provider-events" element={<ProviderEventLog />} />
                            <Route path="admin/events" element={<Events />} />
                            <Route path="admin/home" element={<AdminHome />} />
                            <Route path="admin/server-metrics" element={<ServerMetrics />} />
                            <Route path="admin/offers/suggested" element={<SuggestedOffers />} />
                            <Route path="admin/import-company" element={<ImportCompanyData />} />
                        </Routes>
                    </div>
                </div>

                {mobileMenuActive && <div className="layout-mask modal-in"></div>}
            </div>
        </RTLContext.Provider>
    );
};

export default AccountHome;
